import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { IFederalState } from '../../Interfaces/IAemter';
import { IAdminstrativeUnit } from '../../Interfaces/IAdminstrativeUnit';
import { GemarkungSelector } from '../../Aemter/GemarkungSelector';

interface LegalPhaseAddAdminUnitProps {
  currentAdminUnit?: IAdminstrativeUnit;
  // Beibehalten für Aufruf-Kompatibilität – die neue Auswahl lädt selbst.
  adminUnitArray?: IAdminstrativeUnit[];
  federalStateArray?: IFederalState[];
  onSave: (newAdminUnit: IAdminstrativeUnit | null) => void;
  open: boolean;
  onClose: () => void;
}

export const LegalPhaseAddAdminUnit: React.FC<LegalPhaseAddAdminUnitProps> = ({
  currentAdminUnit,
  onSave,
  open,
  onClose,
}) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<IAdminstrativeUnit | null>(
    null
  );

  useEffect(() => {
    if (open) {
      setSelectedId(currentAdminUnit?.idAdministrativeUnit ?? null);
      setSelectedUnit(currentAdminUnit ?? null);
    } else {
      setSelectedId(null);
      setSelectedUnit(null);
    }
  }, [currentAdminUnit, open]);

  const handleSave = () => {
    onSave(selectedUnit && selectedId ? selectedUnit : null);
    onClose();
  };

  const handleClear = () => {
    onSave(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle>Gemeinde/Gemarkung wählen</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Typography variant='body2' color='text.secondary'>
            Wählen Sie die maßgebliche Gemeinde/Gemarkung. Aus der Auswahl
            werden die zuständigen Gerichte je Gerichtsrolle (Amtsgericht,
            Grundbuchamt, Finanzamt, Handelsregister, …) automatisch abgeleitet.
            Sie können nach Bundesland oder einem konkreten Gericht filtern, um
            die Suche einzugrenzen.
          </Typography>
        </Box>
        <GemarkungSelector
          value={selectedId}
          onChange={(id, unit) => {
            setSelectedId(id);
            setSelectedUnit(
              unit
                ? ({
                    idAdministrativeUnit: unit.idAdministrativeUnit,
                    AdministrativeUnit: unit.AdministrativeUnit,
                    idFederalState: unit.idFederalState ?? 0,
                    FederalState: unit.FederalState,
                    activeUnit: true,
                  } as IAdminstrativeUnit)
                : null
            );
          }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button color='warning' onClick={handleClear}>
          Zuordnung entfernen
        </Button>
        <Box>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button
            variant='contained'
            onClick={handleSave}
            disabled={!selectedId}
          >
            Übernehmen
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
